/**
 * Style for the dev pills. `debugPillStyle(side)` — the black corner-anchored
 * pill — was DELETED 2026-08-20 with its last two consumers (VariantSwitcher,
 * and LocationDebugPanel's collapsed state). The pills live in the People
 * header now, so there is no corner to anchor to.
 */

/**
 * The in-header pill (user design 2026-08-20). Light grey on white, uppercase,
 * small — deliberately quieter than anything the product itself puts in a
 * header, because it must never compete with the page for attention while
 * someone is judging that page's design.
 *
 * Static rather than a function: unlike debugPillStyle above, these sit in
 * normal flow inside the header row, so there is no corner to pick.
 */
export const devPillStyle = {
  background: '#F2F2F4',
  color: '#8E8E93',
  border: 'none',
  borderRadius: '999px',
  padding: '4px 10px',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
};
